import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import SettingsHome from "./Home";
import SystemDetail from "./System/Detail";
import System from "./System/System";
import Tags from "./Tags/Tags";
import CustomFields from "./CustomFields/CustomFields";
import Protector from "../../../router/Protector/Protector";
import Webhook from "./Webhook/Webhook";
import Migration from "./Migration/Migration";
import ContractTypes from "./ContractTypes/ContractTypes";
import CustomizeTheme from "./CustomizeTheme/CustomizeTheme";
import AISettings from "./AISettings/AISettings";
import NavigateToDefault from "../../../router/NavigateToDefault";

class SettingsRouter extends React.Component {
    render() {
        return (
            <Routes caseSensitive>
                <Route path="/" exact element={<Protector><SettingsHome /></Protector>} sensitive />
                <Route path="/tags" exact element={<Protector><Tags /></Protector>} sensitive />
                <Route path="/system" exact element={<Protector><System /></Protector>} sensitive />
                <Route path="/system/:settingId" exact element={<Protector><SystemDetail /></Protector>} sensitive />
                <Route path="/custom-fields" exact element={<Protector><CustomFields /></Protector>} sensitive />
                <Route path="/webhook" exact element={<Protector><Webhook /></Protector>} sensitive />
                <Route path="/migration" exact element={<Protector><Migration /></Protector>} sensitive />
                <Route path="/contract-types" exact element={<Protector><ContractTypes /></Protector>} sensitive />
                <Route path="/customize-theme" exact element={<Protector><CustomizeTheme /></Protector>} sensitive />
                <Route path="/ai-settings" exact element={<Protector><AISettings /></Protector>} sensitive />

                <Route path="*" element={<NavigateToDefault/>} />
            </Routes>
        );
    }

}


export default SettingsRouter;